import {memo} from 'react'

import PropTypes from 'prop-types'

import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS} from './config.js'

const CardCertificationModalContent = ({contentList = []}) => {
  return (
    <div className={`${BASE_CLASS}-modal`}>
      {contentList.map(({description, title}, index) => (
        <div className={`${BASE_CLASS}-modalListItem`} key={index}>
          <TitleBasic
            as={titleBasicTags.h3}
            color={titleBasicColors.black}
            key={index}
            size={titleBasicSizes.xxs}
            title={title}
            description={description}
          />
        </div>
      ))}
    </div>
  )
}

CardCertificationModalContent.displayName = 'CardCertificationModalContent'
CardCertificationModalContent.propTypes = {
  contentList: PropTypes.arrayOf(
    PropTypes.shape({
      iconUrl: PropTypes.string,
      title: PropTypes.string
    })
  )
}

export default memo(CardCertificationModalContent)
